import React, { Suspense, useEffect, useState, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Layout from './components/Layout';
import Spinner from "./components/Spinner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { MyAccount, Profile, PassWord, PlaceOrders, PlaceOrderByNumber } from './components/MyAccount'
import { ProductsManagement, AddProduct, UsersManagement, EditProduct, OrdersManagement } from "./components/Dashboard";
import axios from "axios";
import API_URLS from "./apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { setApiUrl } from "./Redux/reducers/ApiUrlSlice";
import { setUserAvatar, setUserId, setUserName } from "./Redux/reducers/UserSlice";

const Home = lazy(() => import('./components/Home'));
const Dashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const Login = lazy(() => import('./components/Login'));
const Register = lazy(() => import('./components/Register'));

const ProductDetail = lazy(() => import('./components/ProductDetail'));
const Checkout = lazy(() => import('./components/Checkout'));
const Upload = lazy(() => import('./components/upload'));
const Cart = lazy(() => import('./components/Cart'));
const CompeleteOrder = lazy(() => import('./components/CompeleteOder'));






function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticatedAd, setIsAuthenticatedAd] = useState("");
  const [active, setActive] = useState('My Profile');
  const [activeManagement, setActiveManagement] = useState('Products');

  const dispatch = useDispatch()
  let token = localStorage.getItem('token') || [];

  // // Prioritize Production
  // useEffect(() => {
  //   async function getNodeEnv() {
  //     try {
  //       const responseBase = await axios.get(`${API_URLS.base}/api/env`);
  //       if (responseBase.data.nodeEnv === "production") {
  //         await dispatch(setApiUrl(API_URLS.base));
  //         console.log("Connected to Production");
  //       }
  //     } catch (error) {
  //       if (error.message === 'Network Error' || (error.response && error.response.status === 404)) {
  //         try {
  //           const responseProxy = await axios.get(`${API_URLS.proxy}/api/env`);
  //           if (responseProxy.data.nodeEnv === "local") {
  //             await dispatch(setApiUrl(API_URLS.proxy));
  //             console.log("Connected to Local");
  //           }
  //         } catch (err) {
  //           console.error(err.message);
  //         }
  //       } else {
  //         console.error(error.message);
  //       }
  //     }
  //   }

  //   getNodeEnv();
  // }, []);


  // Prioritize Local
  // useEffect(() => {
  //   async function getNodeEnv() {
  //     try {
  //       const responseProxy = await axios.get(`${API_URLS.proxy}/api/env`);
  //       console.log("Connected to Local Server");

  //       // if (responseProxy.data.nodeEnv === "local") {
  //       await dispatch(setApiUrl(API_URLS.proxy));
  //       console.log("Connected to Local Server");
  //       // }
  //     } catch (error) {
  //       if (error.message === 'Network Error' || (error.response && error.response.status === 404)) {
  //         try {
  //                       console.log("Connected to  Production Server");

  //           const responseBase = await axios.get(`${API_URLS.base}/api/env`);
  //           // if (responseBase.data.nodeEnv === "production") {
  //           await dispatch(setApiUrl(API_URLS.base));
  //           console.log("Connected to  Production Server");
  //           // }
  //         } catch (err) {
  //           console.error(err.message);
  //         }
  //       } else {
  //         console.error(error.message);
  //       }
  //     }
  //   }

  //   getNodeEnv();
  // }, []);


  const { apiUrl } = useSelector(state => state.api);


  useEffect(() => {

    if (token) {
      const findInfo = async () => {
        try {
          const response = await axios.get(`${apiUrl}/myaccount`, {
            headers: { token: localStorage.token }
          })
          if (response.status === 200) {
            const parseRes = response.data;
            dispatch(setUserAvatar(parseRes.user_avatar));
            dispatch(setUserName(parseRes.user_name));
            dispatch(setUserId(parseRes.user_id));
          } else if (response.status === 401) {

            return response.text().then(message => {
              console.log(message);
            })
          }
        } catch (err) {
          console.error(err.message);
          // console.error("You are not logged in.");
        }
      }
      findInfo();
    }
  }, [token, dispatch]);




  //Authentization
  const setAuth = boolen => {
    setIsAuthenticated(boolen);
  }


  useEffect(() => {
    const isAuth = async () => {
      try {
        if (apiUrl && token) {
          const response = await axios.get(`${apiUrl}/auth/is-verify`, {
            headers: { token: localStorage.token }
          })
          const parseRes = await response.data;
          setIsAuthenticatedAd(parseRes.checkAuthor);
          (parseRes.isVerify === true) ? setIsAuthenticated(true) : setIsAuthenticated(false);
        }
      } catch (err) {
        console.error(err.response.data);
      }
    }
    isAuth();


  }, [apiUrl, token]);

  return (
    <>

      <BrowserRouter>
        <Suspense
          fallback={
            <Layout>
              <Spinner />
            </Layout>
          }
        >

          <Navbar isAuthenticatedAd={isAuthenticatedAd} setAuth={setAuth} setActive={setActive} active={active} activeManagement={activeManagement} setActiveManagement={setActiveManagement} />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart/:idBuyNow?" element={<Cart />} />
            <Route path="/checkout/:selectedItems?" element={<Checkout />} />
            <Route path="/ordercomplete/:orderNumber" element={<CompeleteOrder />} />
            <Route path="/upload" element={<Upload />} />

            <Route path="/dashboard/" element={<Dashboard isAuthenticatedAd={isAuthenticatedAd} activeManagement={activeManagement} setActiveManagement={setActiveManagement} />}>
              <Route index element={<ProductsManagement />} />
              <Route path="productsmanagement" element={<ProductsManagement />} />
              <Route path="ordersmanagement" element={<OrdersManagement />} />
              <Route path="ordersmanagement/:ordernumber" element={<OrdersManagement />} />
              <Route path="usersmanagement" element={<UsersManagement />} />
            </Route>

            <Route path="/dashboard/addproduct" element={<AddProduct isAuthenticatedAd={isAuthenticatedAd} />} />
            <Route path="/editproduct/:productId" element={<EditProduct isAuthenticatedAd={isAuthenticatedAd} />} />

            <Route path="/myaccount" element={<MyAccount setAuth={setAuth} isAuthenticated={isAuthenticated} setActive={setActive} active={active} />}>
              <Route index element={<Profile />} />
              <Route path="profile" element={<Profile />} />
              <Route path="password" element={<PassWord />} />
              <Route path="placeorders" element={<PlaceOrders />} />
              <Route path="placeorders/:ordernumber" element={<PlaceOrderByNumber />} />
            </Route>


            <Route path="/login" element={!isAuthenticated ? (<Login setAuth={setAuth} />)
              : (<Navigate to="/" />)} />
            <Route path="/register" element={!isAuthenticated ? (<Register setAuth={setAuth} />)
              : (<Navigate to="/" />)} />
            {/* <Route path="/myaccount" element={isAuthenticated ? (<MyAccount setAuth={setAuth} setAuthAd={setAuthAd} />)
              : (<Navigate to="/" />)} /> */}


            <Route path="*" element={<Home />} />

          </Routes>

          <Footer />

        </Suspense>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClickrtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

    </>
  );
}

export default App;

